export const getImageBaseUrl = () => {
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3005/api';
  return apiUrl.replace('/api', '');
};

/** Base URL for static assets (/uploads/...) — derived from VITE_UPLOAD_URL like gestion-partenaires */
export const getUploadBaseUrl = () => {
  const uploadUrl = import.meta.env.VITE_UPLOAD_URL || '';
  if (uploadUrl) {
    return String(uploadUrl)
      .replace(/\/api\/file\/upload\/?$/i, '')
      .replace(/\/$/, '');
  }
  return getImageBaseUrl().replace(/\/$/, '');
};

/** POST upload (fournisseur / transfert véhicules) — same pattern as GestionFournisseur */
export const getUploadFournisseurEndpoint = (directory) => {
  const uploadUrl = (import.meta.env.VITE_UPLOAD_URL || '').replace(/\/?$/, '');
  if (!uploadUrl) return '';
  const base = uploadUrl.replace(/\/upload\/?$/i, '/uploadFournisseur');
  const dir = String(directory || '').replace(/^\/+/, '');
  return `${base}/${dir}`;
};

export const buildAssetUrl = (relativePath) => {
  if (!relativePath) return null;
  const value = String(relativePath);
  if (value.startsWith('http://') || value.startsWith('https://')) return value;
  const base = getUploadBaseUrl();
  const path = value.startsWith('/') ? value : `/${value}`;
  return `${base}${path}`;
};

/** Keep relative /uploads/... path for API persistence when upload returns full URL */
export const normalizeStoredUploadPath = (urlOrPath) => {
  if (!urlOrPath) return '';
  const value = String(urlOrPath).trim();
  if (!/^https?:\/\//i.test(value)) return value;
  try {
    return new URL(value).pathname;
  } catch {
    return value;
  }
};
